import { Action, ActionReducer, MetaReducer, Store } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { JOIN_FEATURE_KEY } from './join/join.selectors';
import { MEMBERSHIP_FEATURE_KEY } from './membership/membership.selectors';
import { AppStore } from './types/store.model';
import { storageCompress, storageDecompress } from './utils/storage-session';
import { environment } from '../../environments/environment';
import { getWindow, ICustomWindow } from '../modules/share/services/window-ref.service';

// Todo: need to move into environment
const isTesting = environment.emulator || environment.ngServe;

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    storage: sessionStorage,
    keys: [
      {
        [JOIN_FEATURE_KEY]: {
          encrypt: storageCompress,
          decrypt: storageDecompress,
          filter: ['formValues'],
        },
      },
      {
        [MEMBERSHIP_FEATURE_KEY]: {
          encrypt: storageCompress,
          decrypt: storageDecompress,
          filter: [
            'accountDetails',
            'clubId',
            'membershipNumber',
            'membershipCodesMap',
            'membershipCodes',
            'membershipCards',
          ],
        },
      },
    ],
    rehydrate: true,
  })(reducer);
}

export function debug(reducer: ActionReducer<any>) {
  return (state: Store<AppStore>, action: Action) => {
    const { type, ...payload } = action;
    console.groupCollapsed(type);
    console.log(payload);
    console.groupEnd();
    return reducer(state, action);
  };
}

class AppState {
  private showSessionId = false;

  actions: string[] = [];
  state: any = {};

  save(type: string, state: any) {
    this.logSessionIdIfNeeded(state);
    this.actions.push(type);
    this.state = state;
  }

  private logSessionIdIfNeeded(state: any): void {
    const sessionId = state?.session?.sessionId;
    if (!this.showSessionId && sessionId) {
      console.log('Session ID', sessionId);
      this.showSessionId = true;
    }
  }
}

export function prodDebug(reducer: ActionReducer<any>) {
  const windowRef = getWindow();

  windowRef.appState = new AppState();

  return (state: Store<AppStore>, action: Action) => {
    const { type } = action;

    windowRef.appState.save(type, state);

    return reducer(state, action);
  };
}

export const metaReducers: Array<MetaReducer<any, any>> = [
  localStorageSyncReducer,
  ...(isTesting ? [debug, prodDebug] : [prodDebug]),
];
